import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from '../../../../../../../../lib/constants/constant';
import { DisplayEuroMUI } from '../../../../../../../../utils/formats';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import { Box } from '@mui/material';
import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from '../../../../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const SachkostenAntragKreativwirtschaftUebersicht: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		{ field: 'bezeichnung', headerName: 'Bezeichnung', width: 400, groupable: false },
		{ field: 'kostenKategorie', headerName: 'Kostenkategorie', flex: 1, groupable: false },
		{ field: 'artDerLeistung', headerName: 'Art der Leistung', flex: 1 },
		{
			field: 'gesamtSumme',
			headerName: 'Geplante Gesamtsumme (€)',
			width: 230,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : 0;
			},
		},
	];

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Sachkosten)
			.map((ele: any) => {
				return {
					id: get(ele, 'id'),
					bezeichnung: get(ele, KP_P.Allgemein_Bezeichnung.path),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path, ''),
					artDerLeistung: get(ele, KP_P.Sachausgaben_Kreativwirtschaft.schema.attributes.Art_Der_Leistung.path, ''),
					gesamtSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return row;
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					gesamtSumme: 'sum',
				},
			},
		};
	}, [application]);

	return (
		<Box sx={{ height: 'auto', width: '100%' }}>
			<ApplicationHeading title='Sachkosten Übersicht' description={PLATZHALTER_TEXT} />
			<DataGridPremium
				rows={rows}
				columns={columns}
				initialState={initialState}
				groupingColDef={{ leafField: 'unternehmen' }}
				hideFooter
				localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
			/>
		</Box>
	);
};
export default SachkostenAntragKreativwirtschaftUebersicht;
